import React from "react"

const Purse = ({ width = "68", height = "60", viewBox = "0 0 68 60" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-purse-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.75 16H46c2.07 0 3.75 1.742 3.75 3.889v2.333c0 .864-.672 1.556-1.5 1.556h-.75c-3.314 0-6 2.784-6 6.222 0 3.438 2.686 6.222 6 6.222h.75c.828 0 1.5.7 1.5 1.556v2.333C49.75 42.258 48.07 44 46 44H19.75C17.68 44 16 42.258 16 40.111V19.89C16 17.742 17.68 16 19.75 16ZM47.5 33.111h3c.828 0 1.5-.692 1.5-1.556v-3.11c0-.856-.672-1.556-1.5-1.556h-3c-1.657 0-3 1.392-3 3.11 0 1.72 1.343 3.112 3 3.112Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-purse-icon"
          x="-6"
          y="-10"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Purse
